<template>
    <div class="row">
        <loading
            :active.sync="loader.isLoading"
            :can-cancel="loader.canCancel"
            :is-full-page="loader.fullPage"
            :color="loader.color"
            :height="loader.height"
            :width="loader.width"
            :background-color="loader.backgroundColor"
            :loader="loader.loader">
            </loading>
        <div class="modal hide fade" id="modalTemplateList" tabindex="-1" role="dialog" aria-labelledby="modalTemplateList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header red darken-3 text-left text-white">
                        <h4 class="modal-title w-100 font-weight-bold">Template List</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <div class="form-inline ml-auto">
                            <div class="button-group">
                                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                                </select>
                                <span class="mr-1">
                                    Total rows: <b>{{ journalTemplateList.length }}</b>
                                </span>
                            </div>
                            <div class="form-group mx-sm-3 mb-2">
                                <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                            </div>
                            <span class="mr-1">
                                page:
                                <select v-model="currentPage">
                                  <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                                </select>
                                / {{ pageLength }}
                            </span>
                            <nav aria-label="Page navigation example" class="pull-right">
                                <ul class="pagination">
                                    <li class="page-item">
                                        <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                    <li class="page-item">
                                        <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                            </div>
                            <table class="table table-item mb-0 table-sm">
                                <thead>
                                    <tr>
                                        <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                            {{ t.name }}
                                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                        </th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr v-if="filterData.length < 1">
                                    <td colspan="9" style="text-align: center;">
                                      <!-- <i>No Data</i> -->
                                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...
                                    </td>
                                </tr>
                                <tr v-for="d in filterData" :key="d.id" style="cursor: pointer">
                                    <td>{{ d.name }}</td>
                                    <td>{{ d.description }}</td>
                                    <td>
                                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="selectTemplate(d.id)">Select</button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'JournalTemplateModal',
  props: ['scroll'],
  components: {
    Loading
  },
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'Name',
        prop: 'name'
      }, {
        name: 'Description',
        prop: 'description'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('getRowTable')
  },
  methods: {
    selectTemplate: function (id) {
      this.$emit('addTemplate', id)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.journalTemplateList.length) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    selectList () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      journalTemplateList: state => state.journals.journalTemplateList,
      rowsTable: state => state.data.rowsTable
    }),
    pageLength: function () {
      var length = this.journalTemplateList.length / this.pageSize
      return Math.ceil(length)
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.journalTemplateList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  }
}
</script>
